/** `serde` transformation type */
export enum SerdeTransformTypeEnum {
  /** Serialize - transform DTO to raw JS object (ready to `JSON.stringify`) */
  SERIALIZE = 'SERIALIZE',
  /** Deserialize - transform raw JS value to DTO */
  DESERIALIZE = 'DESERIALIZE',
}
